// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./i18n";

import App from "./App";
import "./index.css";
import "./api/mockApi"; // Uncomment or comment this line to toggle Mock API
import { WeatherProvider } from "./context/WeatherContext";


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
      <HelmetProvider>
    <BrowserRouter>
      <WeatherProvider>
        <App />
      </WeatherProvider>
    </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
